//////////////////////////////////////////////////////////////////////////////////////////////////
// BEWARE THAT THIS COMPONENT IS ALSO USED IN igbusiness/BmcBlock
// Make sure no to change any interface
//////////////////////////////////////////////////////////////////////////////////////////////////

import React from 'react';

import { Modal, Row, Col, Panel } from 'react-bootstrap';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';

import { STEP_BY_STEP_FORM_COMPONENTS } from './formComponentsArray';
import BmcBlockIcon from '../common_components/bmc/BmcBlockIcon';
import SuggestBlock from './SuggestBlock';

@inject('rootStore')
@observer
class BlockModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleHide = this.handleHide.bind(this);
    this.renderForm = this.renderForm.bind(this);
  }

  render() {
    const { rootStore, blockStore, intl } = this.props;
    return (
      <div>
        <Modal
          className="react-board note-modal-container"
          bsSize="large"
          show={blockStore.showModal}
          onHide={this.handleHide}
        >
          <Row className="note-modal-body-container gray-background">
            <Modal.Header className="note-modal-header-container">
              <div className="lane-header">
                <h4>
                  <BmcBlockIcon block={blockStore.name} />
                  &nbsp;
                  {intl.formatMessage({ id: 'IgbmcBoard-' + blockStore.name })}
                  <button
                    type="button"
                    className="close note-close-button"
                    onClick={this.handleHide}
                  >
                    <span className="glyphicon glyphicon-remove" />
                  </button>
                </h4>
              </div>
            </Modal.Header>

            <Col
              sm={
                blockStore.isEditingCard || !this.props.rootStore.suggestStore
                  ? 12
                  : 7
              }
              className="note-modal-left-col-container"
            >
              <Modal.Body>{this.renderForm()}</Modal.Body>
            </Col>
            {blockStore.isEditingCard ||
            !this.props.rootStore.suggestStore ? null : (
              <Col sm={5} className="note-modal-right-col-container">
                <Modal.Body>
                  <SuggestBlock
                    blockStore={blockStore}
                    suggestStore={this.props.rootStore.suggestStore}
                  />
                </Modal.Body>
              </Col>
            )}
          </Row>
        </Modal>
      </div>
    );
  }

  renderForm() {
    const blockStore = this.props.blockStore;

    const BlockForm = STEP_BY_STEP_FORM_COMPONENTS[blockStore.name];

    return (
      <div>
        <BlockForm blockStore={blockStore} />
      </div>
    );
  }

  handleHide() {
    this.props.blockStore.showBlockModal(false);
  }
}

export default injectIntl(BlockModal);
